import { BiMessageStatus, MessageCategoryEnum, MessageTypeEnum, PriorityEnum } from "@schemax-whatsapp/shared-models/common";
import { TemplateCategories } from "../meta-whatsapp/template-categories.enum";

export class BiMessageModel {
    biMessageId?: number;
    moduleId: number;
    moduleName?: string;
    activity: string;
    roleEscalation: string;
    messageType: MessageTypeEnum;
    messageCategory: TemplateCategories;
    priority: PriorityEnum;
    impact: string;
    rule: string;
    qdc: string;
    username: string;
    messageBody:string;
    templateName:string;
    messageStatus:BiMessageStatus;
    language?:string;
    footer?:string;

    
     /**
     * 
     * @param biMessageId 
     * @param moduleId 
     * @param moduleName 
     * @param roleEscalation 
     * @param activity 
     * @param messageType 
     * @param messageCategory 
     * @param priority 
     * @param impact 
     * @param rule 
     * @param qdc 
     * @param username 
     * @param messageBody 
     * @param templateName 
     * @param messageStatus
     */
    constructor(biMessageId: number, moduleId: number, moduleName: string, roleEscalation: string, activity: string, messageType: MessageTypeEnum, messageCategory: TemplateCategories, priority: PriorityEnum, impact: string, rule: string, qdc: string, username: string,messageBody:string,templateName:string,messageStatus:BiMessageStatus,language?:string,footer?:string) {
        this.biMessageId = biMessageId;
        this.moduleId = moduleId;
        this.roleEscalation = roleEscalation;
        this.moduleName = moduleName;
        this.activity = activity;
        this.messageType = messageType;
        this.messageCategory = messageCategory;
        this.priority = priority;
        this.impact = impact;
        this.rule = rule;
        this.qdc = qdc;
        this.username = username;
        this.messageBody = messageBody;
        this.templateName = templateName;
        this.messageStatus = messageStatus;
        this.language = language;
        this.footer = footer;
    }


}